import React, { useState, useEffect } from 'react'
import { Modal, ListCard, Banner, Filters } from 'components'
import { Api } from 'services'
import './scss/app.scss'
const BRAND = process.env.REACT_APP_BRAND
require(`./scss/brand/${BRAND}.scss`)
const Links = require(`./services/${BRAND}/links/links.json`)
const hasFilterAPI = process.env.REACT_APP_API_GET_PRODUCTS

function App() {
  const [openModal, setOpenModal] = useState(false)
  const [filters, setFilters] = useState([])
  const [links, setLinks] = useState([])
  const [selectedGenders, setSelectedGenders] = useState([])
  const [filterByPrice, setFilterByPrice] = useState('')

  useEffect(() => {
    async function mapNewPrice(link) {
      return {
        id: link.id,
        name: link.name,
        image: link.image,
        url: link.url,
        tags: link.tags,
        genderId: link.genderId,
        linkPriceRange: await getPriceRangeFromApi({
          facet: link.facet,
          linkPriceRange: link.linkPriceRange,
        }),
        facet: link.facet,
      }
    }

    const arrFilters = filters.map(item => item.value)

    const filteredLinks = Links.filter(item => {
      return item.tags.some(tag => arrFilters.includes(tag))
    });

    if (hasFilterAPI) {
      filteredLinks.map(mapNewPrice);
    }

    Promise.all([...filteredLinks]).then(values => {
      setLinks(values)
    })
  }, [filters])

  async function getPriceRangeFromApi({ facet, linkPriceRange }) {

    function _fallbackIfDoesntGetPricesFromApi(response) {
      if (!response.data.facets.length) {
        return {
          from: linkPriceRange.from,
          to: linkPriceRange.to,
        }
      }
    }

    const separator = BRAND === 'anacapri' ? ':' : '='
    const urlToGet = facet.key + separator + facet.value

    const response = await Api().get(urlToGet)
    _fallbackIfDoesntGetPricesFromApi(response)

    const priceFacet = response.data.facets.filter(
      facet => facet.name === 'Preço'
    )
    const priceRanges = [...priceFacet][0].values.map(v => v.name)
    const priceRangesMapped = priceRanges.map(p => {
      let price = ''
      switch (BRAND) {
        case 'schutz':
          price = p.replace(/R\$| /gim, '').split('-')
          break
        case 'anacapri':
          price = p.replace(/Até|R\$| /gim, '').split('-')
          break
        default:
          price = p.replace(/R\$| /gim, '').split('a')
          break
      }
      return price
    })

    priceRangesMapped[0].unshift('0')
    const firstItem = priceRangesMapped[0]
    const lastItem = priceRangesMapped[priceRangesMapped.length - 1]

    return {
      from: firstItem[firstItem.length - 2],
      to: lastItem[lastItem.length - 1],
    }
  }

  function onOpenModal() {
    setOpenModal(true)
  }

  function onCloseModal() {
    setOpenModal(false)
  }

  function getDatafromChild(val) {
    setFilters(val)
  }

  function setFilterPrice(val) {
    setFilterByPrice(val)
  }

  function removeFiltersTag(event) {
    const obj = {
      label: event.target.name,
      value: event.target.value,
    }
    const removedArray = filters.filter(item => item.value !== obj.value)
    setFilters(removedArray)

    if (event.target.dataset.price) {
      setFilterByPrice('')
    }
  }

  function renderHeader() {
    return <Banner handleClick={onOpenModal} />
  }

  function renderFilters() {
    return (
      <Filters
        filters={filters}
        handleClick={onOpenModal}
        handleClickRemoveTag={removeFiltersTag}
        price={filterByPrice}
      />
    )
  }

  function renderModal() {
    return (
      <Modal
        handleClick={onCloseModal}
        sendData={getDatafromChild}
        sendFilterPrice={setFilterPrice}
        setSelectedGenders={setSelectedGenders}
      />
    )
  }

  return (
    <main className={`main ${BRAND}`}>
      {filters.length <= 0 ? renderHeader() : renderFilters()}
      {openModal && renderModal()}

      <div className="content">
        {filters.length > 0 && (
          <div className="container">
            <ListCard links={links} filterByPrice={filterByPrice} selectedGenders={selectedGenders}/>
          </div>
        )}
      </div>
    </main>
  )
}

export default App
